<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="title">S<span class="small1">POOKIEST</span> S<span class="small1">TORIES</span> E<span class="small1">VER</span></h1>
<p class="center"><img alt="" src="OEBPS/images/logo.png"/></p>
<h1 class="subtitle">F<span class="small">OUR</span> S<span class="small">EASONS OF</span> K<span class="small">ENTUCKY</span> G<span class="small">HOSTS</span><br/><br/></h1>
<h1 class="subtitle">R<span class="small">OBERTA</span> S<span class="small">IMPSON</span> B<span class="small">ROWN</span><br/>AND L<span class="small">ONNIE</span> E. B<span class="small">ROWN</span><br/><br/></h1>
<p class="center">F<span class="small">OREWORD BY</span> E<span class="small">LIZABETH</span> T<span class="small">UCKER</span><br/><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/logo3.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780813173894_epub_tp_r1.vue?15c10bf0